import React from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import GenerateAbhaService from "../../../services/GenerateAbhaService";
import { CheckToken } from "../../login/AccessToken";
import ResendOtpTimer from "../../../components/Utils/ResendOtpTimer";
import { toast } from "react-toastify";
import InfoIcon from "@mui/icons-material/Info";
import { Link } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Tooltip from "@mui/material/Tooltip"; // Import for tooltips

import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import CancelIcon from "@mui/icons-material/Cancel";
import ProfileCard from "./ProfileCard";
import { Icons } from "../../doctor-console/Utils/iconsRegistry";

const RESEND_OTP_TIMER = process.env.REACT_APP_RESEND_OTP_TIMER;

const GenerateAbha = ({
  showGenerateModal,
  setHealthIdDetails,
  setShowGenerateModal,
  fetchPatientDetails,
  taggingPatientId,
  setMultiplePatientData,
  setSelectedPartiallyMatchedPatient,
  setPatientData,
  resetForm,
  setTransactionIdForDataVerification,
}) => {
  const [displayOtpVerify, setDisplayOtpVerify] = useState(false);
  const [disableVerifyAndResendOtpButton, setDisableVerifyAndResendOtpButton] =
    useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [otpResendCountGenerate, setOtpResendCountGenerate] = useState(0);
  const [displayGeneratehealthId, setDisplayGeneratehealthId] = useState(false);
  const [genrateAbhaAfterPresent, setGenrateAbhaAfterPresent] = useState(false);
  const [otpResendCountGenerateMobile, setOtpResendCountGenerateMobile] =
    useState(0);
  const [buttonDisabledMobileOtp, setButtonDisabledMobileOtp] = useState(false);
  const [displayVerfiyPhoneNum, setDisplayVerfiyPhoneNum] = useState(false);
  const [isNewUser, setIsNewUser] = useState(false);
  const [
    disableVerifyAndResendOtpMobileButton,
    setDisableVerifyAndResendOtpMobileButton,
  ] = useState(false);
  const [displayDownloadCard, setDisplayDownloadCard] = useState(false);
  const [tokenForProfile, setTokenForProfile] = useState();
  const [updateMobileGenerate, setUpdateMobileGenerate] = useState(false);
  const [txnId, setTxnId] = useState();
  const [suggestionABHA, setSuggestionABHA] = useState(false);
  const [multipleMatchedData, setMultipleMatchedData] = useState([]);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const [healthData, setHealthData] = useState();
  const [disableAbhaGenation, setDisableAbhaGenation] = useState(false);
  const [activePatientId, setActivePatientId] = useState(null);
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const {
    register: register1,
    handleSubmit: handleSubmit1,
    formState: { errors: errors1 },
    getValues: getValues1,
    watch: watch1,
    setValue: setValue1,
    reset: reset1,
  } = useForm();

  const {
    register: register5,
    handleSubmit: handleSubmit5,
    formState: { errors: errors5 },
    setError: setError5,
    getValues: getValues5,
    watch: watch5,
    setValue: setValue5,
    reset: reset5,
  } = useForm();

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    getValues: getValues2,
    setValue: setValue2,
    reset: reset2,
  } = useForm();
  const {
    register: register4,
    handleSubmit: handleSubmit4,
    formState: { errors: errors4 },
    getValues: getValues4,
    setValue: setValue4,
    reset: reset4,
  } = useForm();
  const {
    register: register10,
    handleSubmit: handleSubmit10,
    formState: { errors: errors10 },
    setError: setError10,
    getValues: getValues10,
    watch: watch10,
    reset: reset10,
    setValue: setValue10,
  } = useForm();
  const Token = () => {
    const check = CheckToken();
    console.log(check);
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };
  const checkAllBoxes = () => {
    if (getValues5("check_all") === false) {
      setValue5("consent_1", true);
      setValue5("consent_2", true);
      setValue5("consent_3", true);
      setValue5("consent_4", true);
      setValue5("consent_5", true);
      setValue5("consent_6", true);
      setValue5("consent_7", true);
    } else {
      setValue5("consent_1", false);
      setValue5("consent_2", false);
      setValue5("consent_3", false);
      setValue5("consent_4", false);
      setValue5("consent_5", false);
      setValue5("consent_6", false);
      setValue5("consent_7", false);
    }
  };
  const checkboxes = watch5([
    "consent_1",
    "consent_2",
    "consent_3",
    "consent_4",
    "consent_5",
    "consent_6",
    "consent_7",
  ]);
  const isAllChecked = checkboxes.every((checkbox) => checkbox);

  const submitAadhaar = async (data, e) => {
    e.preventDefault();

    if (Token() && isAllChecked) {
      const aadhaar = getValues1("Aadhaar_number");
      const post_data = {
        txnId: "",
        scope: ["abha-enrol"],
        loginHint: "aadhaar",
        loginId: aadhaar,
        otpSystem: "aadhaar",
        terms_conditions: isAllChecked,
      };

      try {
        const response = await GenerateAbhaService.generateAdharOtpAbha(
          post_data,
          headers
        );
        console.log(response);
        if (response.data.txnId && response.data.message) {
          setTxnId(response.data.txnId);
          setDisplayOtpVerify(true);
          handleGenerateOtpResend();
        }
      } catch (err) {
        console.error("Failed to generate Aadhaar OTP:", err);
      }
    }
  };

  const submitOTP = async (data, e) => {
    const post_data = {
      authData: {
        authMethods: ["otp"],
        otp: {
          timeStamp: new Date().toISOString(),
          txnId: txnId,
          otpValue: getValues2("otp"),
          mobile: getValues2("phone"),
        },
      },
      consent: {
        code: "abha-enrollment",
        version: "1.4",
      },
    };
    console.log("phone", getValues2("phone"));
    if (Token()) {
      try {
        const response = await GenerateAbhaService.enrolByAadhaar(
          post_data,
          headers
        );
        console.log(response);
        setHealthData(response.data);
        if (response.data.ABHAProfile.mobile !== getValues2("phone")) {
          setDisableVerifyAndResendOtpButton(true);
          // setUpdateMobileGenerate(true);
          setValue10("phone", getValues2("phone"));
          if (response.data.isNew === true) {
            setIsNewUser(true);
            setTokenForProfile(response.data.tokens.token);
          } else {
            setIsNewUser(false);
            setTokenForProfile(response.data.tokens.token);
          }
          sendOtpMobileUpdate();
        } else {
          setTokenForProfile(response.data.tokens.token);
          if (response.data.isNew === false) {
            const post_data = {
              token: response.data.tokens.token,
              patient_id: taggingPatientId,
            };
            const response1 = await GenerateAbhaService.getProfileV3(
              post_data,
              headers
            );
            console.log(response1);
            setDisableVerifyAndResendOtpButton(true);
            setGenrateAbhaAfterPresent(true);
            getSuggestions();
            setDisplayDownloadCard(true);
            if (response1.data.patient_id) {
              console.log(
                "response1.data.patient_id",
                response1.data.patient_id
              );
              toast.error(
                `Patient ID already present with this ABHA address ${response1.data.patient_id} `
              );
            }

            // else if (response1.data.patient ) {
            //   setMultipleMatchedData(response1.data);
            //   toast.error("profile does not match! please choose from the cards");
            // }
            else if (
              response1.data.patient &&
              (!response1.data.message ||
                response1.data.message !== "Patient updated successfully !!")
            ) {
              setMultipleMatchedData(response1.data);
              toast.error(
                "Patient demographics matching with multiple existing patient records.Please choose from the cards."
              );
              setTransactionIdForDataVerification(
                response1.data.transaction_id_internal
              );
            } else if (response1.data.message) {
              toast.success(response1.data.message);
              setHealthIdDetails(response1.data);
            } else {
              setHealthIdDetails(response1.data);
            }
          } else {
            setDisableVerifyAndResendOtpButton(true);
            getSuggestions();
            setDisplayGeneratehealthId(true);
          }
        }
      } catch (err) {
        console.error("Failed to generate Aadhaar OTP:", err);
      }
    }
  };

  const resendOTP = async () => {
    if (Token()) {
      const aadhaar = getValues1("Aadhaar_number");
      const post_data = {
        txnId: "",
        scope: ["abha-enrol"],
        loginHint: "aadhaar",
        loginId: aadhaar,
        otpSystem: "aadhaar",
        terms_conditions: isAllChecked,
      };

      try {
        const response = await GenerateAbhaService.generateAdharOtpAbha(
          post_data,
          headers
        );
        console.log(response);
        if (response.data.txnId && response.data.message) {
          setTxnId(response.data.txnId);
          handleGenerateOtpResend();
        }
      } catch (err) {
        console.error("Failed to generate Aadhaar OTP:", err);
      }
    }
  };

  const generatehealthId = async (data, e) => {
    e.preventDefault();

    if (Token()) {
      var post_data = {};
      post_data.txnId = txnId;
      post_data.preferred = 1;
      post_data.abhaAddress = getValues5("abhaAddress");
      post_data.patient_id = taggingPatientId;
      if (Token()) {
        try {
          const response = await GenerateAbhaService.generateHealthId(
            post_data,
            headers
          );
          if (
            response.data.healthIdNumber &&
            response.data.preferredAbhaAddress
          ) {
            setDisableAbhaGenation(true);
            console.log(response);
            const post_data1 = {
              token: tokenForProfile,
              patient_id: taggingPatientId,
            };
            const response1 = await GenerateAbhaService.getProfileV3(
              post_data1,
              headers
            );
            console.log(response1);
            if (response1.data.patient_id) {
              console.log(
                "response1.data.patient_id",
                response1.data.patient_id
              );
              toast.error(
                `Patient ID already present with this ABHA address ${response1.data.patient_id} `
              );
            }
            // else if (response1.data.patient) {
            //   setMultipleMatchedData(response1.data);
            //   toast.error("profile does not match! please choose from the cards");
            // }
            else if (
              response1.data.patient &&
              (!response1.data.message ||
                response1.data.message !== "Patient updated successfully !!")
            ) {
              setMultipleMatchedData(response1.data);
              toast.error(
                "Patient demographics matching with multiple existing patient records.Please choose from the cards."
              );
              setTransactionIdForDataVerification(
                response1.data.transaction_id_internal
              );
            } else if (response1.data.message) {
              toast.success(response1.data.message);
              setHealthIdDetails(response1.data);
            } else {
              setHealthIdDetails(response1.data);
            }
            setDisplayDownloadCard(true);
          }
        } catch (err) {
          console.error("Failed to generate Aadhaar OTP:", err);
        }
      }
    }
  };
  const getSuggestions = async () => {
    if (Token()) {
      var post_data = {};
      post_data.Transaction_id = txnId;

      if (Token()) {
        try {
          const response = await GenerateAbhaService.getAbhaSuggestionV3(
            post_data,
            headers
          );
          console.log(response);
          setSuggestionABHA(response.data.abhaAddressList);
        } catch (err) {
          console.error("Failed to generate Aadhaar OTP:", err);
        }
      }
    }
  };

  const handleGenerateOtpResend = () => {
    console.log("currentCount", otpResendCountGenerate);
    if (otpResendCountGenerate <= 2) {
      setOtpResendCountGenerate((prevCount) => prevCount + 1);
      setButtonDisabled(true);

      if (otpResendCountGenerate < 2) {
        setTimeout(() => {
          setButtonDisabled(false);
        }, RESEND_OTP_TIMER);
      }
    } else {
      toast.error(
        "You have reached the maximum number of resend attempts. Please try again later."
      );
    }
  };
  const resendMobileOTP = async () => {
    console.log("inside fn");
    if (Token()) {
      const mobile = getValues10("phone");
      const txnIdToSet = txnId;

      const post_data = {
        txnId: txnIdToSet,
        scope: ["abha-enrol", "mobile-verify"],
        loginHint: "mobile",
        loginId: mobile,
        otpSystem: "abdm",
      };

      try {
        const response = await GenerateAbhaService.sendOtpMobileUpdate(
          post_data,
          headers
        );
        console.log(response);
        if (response.data.txnId && response.data.message) {
          setTxnId(response.data.txnId);
          handleGenerateOtpResendMobile();
        }
      } catch (err) {
        console.error("Failed to generate Aadhaar OTP:", err);
      }
    }
  };

  const handleGenerateOtpResendMobile = () => {
    // console.log("currentCount", otpResendCountGenerateMobile);
    if (otpResendCountGenerateMobile <= 3) {
      setOtpResendCountGenerateMobile((prevCount) => prevCount + 1);
      setButtonDisabledMobileOtp(true);

      if (otpResendCountGenerateMobile < 2) {
        setTimeout(() => {
          setButtonDisabledMobileOtp(false);
        }, RESEND_OTP_TIMER);
      }
    } else {
      toast.error(
        "You have reached the maximum number of resend attempts. Please try again later."
      );
    }
  };
  const sendOtpMobileUpdate = async (data, e) => {
    console.log("inside fn");
    if (Token()) {
      const mobile = getValues2("phone");
      const txnIdToSet = txnId;

      const post_data = {
        txnId: txnIdToSet,
        scope: ["abha-enrol", "mobile-verify"],
        loginHint: "mobile",
        loginId: mobile,
        otpSystem: "abdm",
      };

      try {
        const response = await GenerateAbhaService.sendOtpMobileUpdate(
          post_data,
          headers
        );
        console.log(response);
        if (response.data.txnId && response.data.message) {
          setTxnId(response.data.txnId);
          setDisplayVerfiyPhoneNum(true);
          handleGenerateOtpResendMobile();
        }
      } catch (err) {
        console.error("Failed to generate Aadhaar OTP:", err);
      }
    }
  };

  const verifyPhoneNum = async (data, e) => {
    e.preventDefault();

    if (Token()) {
      const txnIdToSend = txnId;

      const post_data = {
        scope: ["abha-enrol", "mobile-verify"],
        authData: {
          authMethods: ["otp"],
          otp: {
            timeStamp: new Date().toISOString(),
            txnId: txnIdToSend,
            otpValue: getValues4("mobileOTP"),
          },
        },
      };

      try {
        const response = await GenerateAbhaService.verifyOtpMobileUpdate(
          post_data,
          headers
        );
        console.log(response);
        console.log("tokenForProfile", tokenForProfile);
        console.log("isNewUser", isNewUser);
        console.log("getValues10(phone)", getValues10("phone"));
        console.log("healthData", healthData.ABHAProfile.mobile);

        if (!isNewUser && response.data.authResult === "success") {
          if (healthData.message == "This account already exist") {
            toast.success("This account already exist");
          }
          setDisableVerifyAndResendOtpMobileButton(true);
          const post_data = {
            token: tokenForProfile,
            patient_id: taggingPatientId,
          };
          const response1 = await GenerateAbhaService.getProfileV3(
            post_data,
            headers
          );
          console.log(response1);
          setDisableVerifyAndResendOtpButton(true);
          setGenrateAbhaAfterPresent(true);
          getSuggestions();
          setDisplayDownloadCard(true);

          if (response1.data.patient_id) {
            console.log("response1.data.patient_id", response1.data.patient_id);
            toast.error(
              `Patient ID already present with this ABHA address ${response1.data.patient_id} `
            );
          }
          //  else if (response1.data.patient) {
          //   setMultipleMatchedData(response1.data);
          //   toast.error("profile does not match! please choose from the cards");
          // }
          else if (
            response1.data.patient &&
            (!response1.data.message ||
              response1.data.message !== "Patient updated successfully !!")
          ) {
            setMultipleMatchedData(response1.data);
            toast.error(
              "Patient demographics matching with multiple existing patient records.Please choose from the cards."
            );
            setTransactionIdForDataVerification(
              response1.data.transaction_id_internal
            );
          } else if (response1.data.message) {
            toast.success(response1.data.message);
            setHealthIdDetails(response1.data);
          } else {
            setHealthIdDetails(response1.data);
          }
        } else if (response.data.authResult === "success") {
          getSuggestions();
          setDisplayGeneratehealthId(true);
          setDisableVerifyAndResendOtpMobileButton(true);
        }
      } catch (err) {
        console.error("Failed to generate Aadhaar OTP:", err);
      }
    }
  };
  const downloadABHAUsingTokenPdf = async () => {
    if (Token()) {
      const post_data_for_card = {
        token: tokenForProfile,
      };
      try {
        const response = await GenerateAbhaService.getAbhaCardV3(
          post_data_for_card,
          headers
        );
        console.log(response);
        var blob = b64toBlob(response.data.value, "image/png");
        const url = window.URL.createObjectURL(blob);
        const pdfWindow = window.open("");
        pdfWindow.document.write(
          "<img width='100%' height='100%' src='" + url + "'></img>"
        );
      } catch (err) {
        console.error("Failed to generate Aadhaar OTP:", err);
      }
    }
  };
  var b64toBlob = function (b64Data, contentType, sliceSize) {
    contentType = contentType || "";
    sliceSize = sliceSize || 512;
    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  const handleCloseGenerateModal = () => {
    setDisplayOtpVerify(false);
    setDisableVerifyAndResendOtpButton(false);
    setButtonDisabled(false);
    setOtpResendCountGenerate(0);
    setDisplayGeneratehealthId(false);
    setGenrateAbhaAfterPresent(false);
    setOtpResendCountGenerateMobile(0);
    setButtonDisabledMobileOtp(false);
    setDisplayVerfiyPhoneNum(false);
    setIsNewUser(false);
    setDisableVerifyAndResendOtpMobileButton(false);
    setDisplayDownloadCard(false);
    setTokenForProfile(undefined);
    setUpdateMobileGenerate(false);
    setTxnId(undefined);
    setSuggestionABHA(false);
    setDisableAbhaGenation(false);
    reset1();
    reset2();
    reset4();
    reset5();
    reset10();
    setShowGenerateModal(false);
    fetchPatientDetails();
    setMultiplePatientData([]);
    setMultipleMatchedData([]);
  };

  const handleAddNewPatient = (patient) => {
    // Set the selected partially matched patient data
    resetForm();
    setSelectedPartiallyMatchedPatient(multipleMatchedData);
    console.log("Adding new patient :", multipleMatchedData);
    handleCloseGenerateModal();
  };

  const handleUpdatePatient = (patientId) => {
    const patient = multipleMatchedData.patient.find(
      (p) => p.patient_id === patientId
    );
    // Logic to update the patient
    resetForm();
    console.log("Updating patient with ID:", patient);

    const formattedMonth = multipleMatchedData.monthOfBirth
      ? String(multipleMatchedData.monthOfBirth).padStart(2, "0")
      : "";
    const formattedDay = multipleMatchedData.dayOfBirth
      ? String(multipleMatchedData.dayOfBirth).padStart(2, "0")
      : "";
    const formattedDateOfBirth = multipleMatchedData.yearOfBirth
      ? `${multipleMatchedData.yearOfBirth}-${formattedMonth}-${formattedDay}`
      : null;

    const mergedData = {
      patient_id: patient.patient_id,
      name: multipleMatchedData.name || patient.name,
      first_name: multipleMatchedData.firstName || patient.first_name,
      middle_name: multipleMatchedData.middleName || patient.middle_name,
      last_name: multipleMatchedData.lastName || patient.last_name,
      abha_id: multipleMatchedData.preferredAbhaAddress || patient.abha_id,
      abha_no: multipleMatchedData.ABHANumber || patient.abha_no,
      gender: multipleMatchedData.gender || patient.gender,
      email: multipleMatchedData.email || patient.email,
      pincode: multipleMatchedData.pincode || patient.pincode,
      city: multipleMatchedData.townName || patient.city,
      state: multipleMatchedData.stateName || patient.state,
      district: multipleMatchedData.districtName || patient.district,
      address_line: multipleMatchedData.address || patient.address_line,
      age: multipleMatchedData.age || patient.age,
      dob: formattedDateOfBirth,
      phone_no: multipleMatchedData.mobile || patient.phone_no,
      photo: multipleMatchedData.profilePhoto || patient.photo,
      height: patient.height,
      weight: patient.weight,
      health_insurance: patient.health_insurance,
      facility: patient.facility,
    };

    console.log("mergedData", mergedData);
    setPatientData(mergedData);
    handleCloseGenerateModal();
  };

  const handleCancelUpdate = (patientId) => {
    // Logic to cancel the update
    console.log("Cancelling update for patient with ID:", patientId);
    handleCloseGenerateModal();
  };

  const handleCardSelect = (patientId) => {
    setActivePatientId(patientId);
  };

  console.log("test", multipleMatchedData);
  return (
    <>
      <Modal
        show={showGenerateModal}
        onHide={handleCloseGenerateModal}
        centered
        backdrop="static"
        className="register-modal"
        style={{ zIndex: 9997 }}
      >
        <Modal.Header
          style={{
            // backgroundImage: `url(${Icons.modal_blue})`,
            backgroundColor: "#213360",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            color: "white",
            display: "flex",
            justifyContent: "space-between", // pushes title left, button right
            alignItems: "center",
          }}
        >
          <Modal.Title style={{ margin: 0 }}>Generate ABHA</Modal.Title>
          <button
            type="button"
            onClick={handleCloseGenerateModal}
            aria-label="Close"
            style={{
              WebkitMaskImage:
                "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586l6.293-6.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\")",
              WebkitMaskRepeat: "no-repeat",
              WebkitMaskPosition: "center",
              WebkitMaskSize: "contain",
              backgroundColor: "white", // makes the "X" white
              width: "1rem",
              height: "1rem",
              border: "none",
              cursor: "pointer",
            }}
          />
        </Modal.Header>
        <Modal.Body style={{ overflowY: "auto", width: "100%" }}>
          {/* <h1 style={{ textAlign: "center" }}>Generate ABHA</h1> */}

          <div className="contact-panel mb-50">
            <form
              className="contact-panel__form"
              onSubmit={handleSubmit1(submitAadhaar)}
            >
              <div className="row">
                <div className="col-sm-8 col-md-8 col-lg-8">
                  <div className="form-group">
                    <i className="icon-news form-group-icon"></i>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Aadhaar Number"
                      name="Aadhaar_number"
                      {...register1("Aadhaar_number", {
                        required: "Aadhaar Number is required.",
                        minLength: {
                          value: 12,
                          message: "Aadhaar Number must be 12 digits long.",
                        },
                        maxLength: {
                          value: 12,
                          message: "Aadhaar Number must be 12 digits long.",
                        },
                        pattern: {
                          value: /^[0-9]{12}$/,
                          message: "Aadhaar Number must contain only numbers.",
                        },
                        validate: {
                          noSpaces: (value) =>
                            value.trim() === value || "Spaces are not allowed.",
                        },
                      })}
                    />
                    {errors1.Aadhaar_number && (
                      <p className="errorMsg" style={{ color: "red" }}>
                        {errors1.Aadhaar_number.message}
                      </p>
                    )}
                  </div>
                </div>

                <div className="col-sm-4 col-md-4 col-lg-4">
                  <button
                    disabled={!isAllChecked || displayOtpVerify}
                    type="submit"
                    className="btn btn__secondary btn__rounded mt-6"
                  >
                    <span>Submit</span> <i className="icon-arrow-right"></i>
                  </button>
                  <div className="contact-result"></div>
                </div>

                <div>
                  <label>
                    <input
                      type="checkbox"
                      onClick={() => checkAllBoxes()}
                      {...register5("check_all")}
                    />
                    <nbsp /> <nbsp /> <nbsp /> <nbsp /> <nbsp />
                    Check / Uncheck All
                  </label>
                  <nbsp /> <nbsp /> <nbsp /> <nbsp /> <nbsp />
                  <label>
                    <input
                      type="checkbox"
                      {...register5("consent_1", {
                        required: "Consent is required.",
                      })}
                    />{" "}
                    <nbsp /> <nbsp /> <nbsp /> <nbsp /> <nbsp />I am voluntarily
                    sharing my Aadhaar Number / Virtual ID issued by the Unique
                    Identification Authority of India (“UIDAI”), and my
                    demographic information for the purpose of creating an
                    Ayushman Bharat Health Account number (“ABHA number”) and
                    Ayushman Bharat Health Account address (“ABHA Address”).
                    <br /> I authorize NHA to use my Aadhaar number / Virtual ID
                    for performing Aadhaar based authentication with UIDAI as
                    per the provisions of the Aadhaar (Targeted Delivery of
                    Financial and other Subsidies, Benefits and Services) Act,
                    2016 for the aforesaid purpose.I understand that UIDAI will
                    share my e-KYC details, or response of “Yes” with NHA upon
                    successful authentication.
                    <br />
                  </label>
                  {errors5.consent_1 && (
                    <p style={{ color: "red" }}>{errors5.consent_1.message}</p>
                  )}
                  <label>
                    <input
                      type="checkbox"
                      {...register5("consent_2", {
                        required: "Consent is required.",
                      })}
                    />{" "}
                    <nbsp /> <nbsp /> <nbsp /> <nbsp /> <nbsp />I intend to
                    create Ayushman Bharat Health Account Number (“ABHA number”)
                    and Ayushman Bharat Health Account address (“ABHA Address”)
                    using document other than Aadhaar.
                  </label>
                  {errors5.consent_2 && (
                    <p style={{ color: "red" }}>{errors5.consent_2.message}</p>
                  )}
                  <label>
                    <input
                      type="checkbox"
                      {...register5("consent_3", {
                        required: "Consent is required.",
                      })}
                    />{" "}
                    <nbsp /> <nbsp /> <nbsp /> <nbsp /> <nbsp />I consent to
                    usage of my ABHA address and ABHA number for linking of my
                    legacy (past) health records and those which will be
                    generated during this encounter.
                  </label>
                  {errors5.consent_3 && (
                    <p style={{ color: "red" }}>{errors5.consent_3.message}</p>
                  )}
                  <label>
                    <input
                      type="checkbox"
                      {...register5("consent_4", {
                        required: "Consent is required.",
                      })}
                    />{" "}
                    <nbsp /> <nbsp /> <nbsp /> <nbsp /> <nbsp />I authorize the
                    sharing of all my health records with healthcare provider(s)
                    for the purpose of providing healthcare services to me
                    during this encounter.
                  </label>
                  {errors5.consent_4 && (
                    <p style={{ color: "red" }}>{errors5.consent_4.message}</p>
                  )}
                  <label>
                    <input
                      type="checkbox"
                      {...register5("consent_5", {
                        required: "Consent is required.",
                      })}
                    />{" "}
                    <nbsp /> <nbsp /> <nbsp /> <nbsp /> <nbsp />I consent to the
                    anonymization and subsequent use of my health records for
                    public health purposes.
                  </label>
                  {errors5.consent_5 && (
                    <p style={{ color: "red" }}>{errors5.consent_5.message}</p>
                  )}
                  <label>
                    <input
                      type="checkbox"
                      {...register5("consent_6", {
                        required: "Consent is required.",
                      })}
                    />{" "}
                    <nbsp /> <nbsp /> <nbsp /> <nbsp /> <nbsp />
                    I, {sessionStorage.getItem("name")}, confirm that I have
                    duly informed and explained the beneficiary of the contents
                    of consent for aforementioned purposes.
                  </label>
                  {errors5.consent_6 && (
                    <p style={{ color: "red" }}>{errors5.consent_6.message}</p>
                  )}
                  <label>
                    <input
                      type="checkbox"
                      {...register5("consent_7", {
                        required: "Consent is required.",
                      })}
                    />{" "}
                    <nbsp /> <nbsp /> <nbsp /> <nbsp /> <nbsp />I have been
                    explained about the consent as stated above and hereby
                    provide my consent for the aforementioned purposes.
                  </label>
                  {errors5.consent_7 && (
                    <p style={{ color: "red" }}>{errors5.consent_7.message}</p>
                  )}
                </div>
              </div>
            </form>

            {displayOtpVerify ? (
              <form
                className="contact-panel__form"
                style={{ paddingTop: "2%" }}
                onSubmit={handleSubmit2(submitOTP)}
              >
                <h4>
                  <strong>Confirm OTP</strong>
                </h4>
                <div className="row">
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <i className="icon-news form-group-icon"></i>
                      <input
                        disabled={disableVerifyAndResendOtpButton}
                        type="text"
                        className="form-control"
                        placeholder="OTP"
                        name="otp"
                        {...register2("otp", {
                          required: "OTP is required.",
                        })}
                      />
                      {errors2.otp && (
                        <p className="errorMsg" style={{ color: "red" }}>
                          {errors2.otp.message}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <i className="icon-news form-group-icon"></i>
                      <input
                        disabled={disableVerifyAndResendOtpButton}
                        type="text"
                        className="form-control"
                        placeholder="Phone Number"
                        name="phone"
                        {...register2("phone", {
                          required: "Phone is required.",
                          pattern: {
                            value: /^[0-9]{10}$/,
                            message: "Phone number must be a 10-digit number.",
                          },
                        })}
                      />
                      {errors2.phone && (
                        <p className="errorMsg" style={{ color: "red" }}>
                          {errors2.phone.message}
                        </p>
                      )}
                    </div>
                  </div>
                  {/* <div className="col-sm-6 col-md-6 col-lg-6"></div>
                  <div className="col-sm-6 col-md-6 col-lg-6"> */}
                  <p
                    style={{
                      color: "blue",
                      marginLeft: "2%",
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "2px",
                    }}
                  >
                    <InfoIcon style={{ marginRight: "8px" }} />
                    This phone number will be used for all the communications
                    related to ABHA.
                  </p>
                  {/* </div> */}

                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <button
                      type="submit"
                      id="check_health_id"
                      className="btn btn__secondary btn__rounded btn__block btn__xhight mt-6"
                      disabled={disableVerifyAndResendOtpButton}
                    >
                      <span>Verify</span> <i className="icon-arrow-right"></i>
                    </button>
                    <div className="contact-result"></div>
                  </div>
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <button
                      type="button"
                      disabled={
                        disableVerifyAndResendOtpButton
                          ? disableVerifyAndResendOtpButton
                          : buttonDisabled
                      }
                      onClick={() => resendOTP()}
                      id="check_health_id"
                      className="btn btn__secondary btn__rounded btn__block btn__xhight mt-6"
                    >
                      <span>Resend OTP</span>{" "}
                      {buttonDisabled &&
                        otpResendCountGenerate < 3 &&
                        otpResendCountGenerate > 0 && (
                          <ResendOtpTimer duration={RESEND_OTP_TIMER} />
                        )}
                      <i className="icon-arrow-right"></i>
                    </button>
                    <div className="contact-result"></div>
                  </div>
                  {/* <p
                    style={{
                      color: "blue",
                      marginTop: "20px",
                      marginLeft: "2%",
                    }}
                  >
                    This mobile number will be used for all the communications
                    related to ABHA.
                  </p> */}
                </div>
              </form>
            ) : (
              []
            )}

            {updateMobileGenerate ? (
              <form
                className="contact-panel__form"
                style={{ paddingTop: "2%" }}
                onSubmit={handleSubmit10(sendOtpMobileUpdate)}
              >
                <h4>
                  <strong>Communication number</strong>
                </h4>
                <div className="row">
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <i className="icon-news form-group-icon"></i>
                      <input
                        disabled={displayVerfiyPhoneNum}
                        type="text"
                        className="form-control"
                        placeholder="Phone Number"
                        name="phone"
                        {...register10("phone", {
                          required: "Phone is required.",
                          pattern: {
                            value: /^[0-9]{10}$/,
                            message: "Phone number must be a 10-digit number.",
                          },
                        })}
                      />
                      {errors10.phone && (
                        <p className="errorMsg" style={{ color: "red" }}>
                          {errors10.phone.message}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <button
                      disabled={displayVerfiyPhoneNum}
                      type="submit"
                      id="submit_no_update"
                      className="btn btn__secondary btn__rounded btn__block btn__xhight mt-6"
                    >
                      <span>Submit</span> <i className="icon-arrow-right"></i>
                    </button>
                    <div className="contact-result"></div>
                  </div>
                </div>
              </form>
            ) : (
              []
            )}

            {displayVerfiyPhoneNum ? (
              <form
                className="contact-panel__form"
                style={{ paddingTop: "5%" }}
                onSubmit={handleSubmit4(verifyPhoneNum)}
              >
                <h4>
                  <strong>Confirm communication OTP</strong>
                </h4>
                <div className="row" style={{ marginBottom: "20px" }}>
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <i className="icon-news form-group-icon"></i>
                      <input
                        disabled={disableVerifyAndResendOtpMobileButton}
                        type="text"
                        className="form-control"
                        placeholder="Enter OTP"
                        name="mobileOTP"
                        {...register4("mobileOTP", {
                          required: "OTP is required.",
                        })}
                      />
                      {errors4.mobileOTP && (
                        <p className="errorMsg" style={{ color: "red" }}>
                          {errors4.mobileOTP.message}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-6 col-lg-6"></div>
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <button
                      type="submit"
                      id="check_health_id"
                      className="btn btn__secondary btn__block btn__rounded mt-6"
                      disabled={disableVerifyAndResendOtpMobileButton}
                    >
                      <span>Verify Mobile OTP</span>{" "}
                      <i className="icon-arrow-right"></i>
                    </button>
                    <div className="contact-result"></div>
                  </div>
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <button
                      type="button"
                      disabled={
                        disableVerifyAndResendOtpMobileButton
                          ? disableVerifyAndResendOtpMobileButton
                          : buttonDisabledMobileOtp
                      }
                      onClick={() => resendMobileOTP()}
                      id="check_health_id"
                      className="btn btn__secondary btn__rounded btn__block btn__xhight mt-6"
                    >
                      <span>Resend Mobile OTP</span>{" "}
                      {buttonDisabledMobileOtp &&
                        otpResendCountGenerateMobile < 3 &&
                        otpResendCountGenerateMobile > 0 && (
                          <ResendOtpTimer duration={RESEND_OTP_TIMER} />
                        )}
                      <i className="icon-arrow-right"></i>
                    </button>
                    <div className="contact-result"></div>
                  </div>
                </div>
              </form>
            ) : (
              []
            )}

            {/* {genrateAbhaAfterPresent ? (
              <div>
                <h4>
                  <strong>Generate Another ABHA Address</strong>
                </h4>
                <div className="row" style={{ marginBottom: "20px" }}>
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <button
                      type="button"
                      id="reGenrateAbha"
                      className="btn btn__secondary btn__block btn__rounded mt-6 "
                      disabled={displayGeneratehealthId}
                      onClick={() => setDisplayGeneratehealthId(true)}
                    >
                      <span>Generate another ABHA</span>{" "}
                      <i className="icon-arrow-right"></i>
                    </button>
                    <div className="contact-result"></div>
                  </div>
                </div>
              </div>
            ) : (
              []
            )} */}
            {genrateAbhaAfterPresent ? (
              <div className="col-sm-6 col-md-6 col-lg-6">
                <Link
                  href="#"
                  // onClick={() => setDisplayGeneratehealthId(true)}
                  onClick={() => {
                    setDisplayGeneratehealthId(true);
                    setMultipleMatchedData([]);
                  }}
                  style={{
                    marginTop: "7px",
                    marginBottom: "7px",
                    cursor: displayGeneratehealthId ? "not-allowed" : "pointer",
                  }}
                  className="hyperlink"
                >
                  Click here to generate another ABHA
                </Link>
              </div>
            ) : (
              []
            )}

            {displayGeneratehealthId ? (
              <form
                className="contact-panel__form"
                style={{ paddingTop: "5%" }}
                onSubmit={handleSubmit5(generatehealthId)}
              >
                <h4>
                  <strong>Generate ABHA Address</strong>
                </h4>
                <div className="row">
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <i className="icon-news form-group-icon"></i>
                      <input
                        disabled={disableAbhaGenation}
                        type="text"
                        className="form-control"
                        placeholder="Enter ABHA address"
                        name="abhaAddress"
                        {...register5("abhaAddress", {
                          required: "ABHA Address is required",
                          pattern: {
                            value:
                              /^(?=.{8,18}$)(?=.*[a-zA-Z0-9])([a-zA-Z0-9]+[._]?[a-zA-Z0-9]+)$/,
                            message:
                              "Invalid ABHA Address format. Must be 8-18 characters, alphanumeric, with optional dot/underscore in the middle.",
                          },
                        })}
                      />
                      <br />
                      <label style={{ paddingLeft: "2%" }}>
                        {suggestionABHA !== undefined &&
                        suggestionABHA.length > 0
                          ? "Suggestions : " + suggestionABHA.join(" , ")
                          : ""}
                      </label>
                      {errors5.abhaAddress && (
                        <p className="errorMsg" style={{ color: "red" }}>
                          {errors5.abhaAddress.message}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <button
                      disabled={disableAbhaGenation}
                      type="submit"
                      id="check_health_id"
                      className="btn btn__secondary btn__block btn__rounded mt-6"
                    >
                      <span>Generate ABHA Address</span>{" "}
                      <i className="icon-arrow-right"></i>
                    </button>
                    <div className="contact-result"></div>
                  </div>
                </div>
              </form>
            ) : (
              []
            )}
            {displayDownloadCard && (
              <button
                type="button"
                id="check_health_card"
                className={`btn btn__secondary btn__block btn__rounded mt-6`}
                onClick={downloadABHAUsingTokenPdf}
              >
                <span>Download ABHA CARD</span>{" "}
                <i className="icon-arrow-right"></i>
              </button>
            )}
          </div>
          {/* {multipleMatchedData &&
            multipleMatchedData.patient &&
            multipleMatchedData.patient.length > 0 && (
              <Box
                sx={{
                  height: "600px",
                  overflow: "auto",
                  padding: "16px",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                }}
              >
                <form>
                  <Typography
                    variant="h6"
                    style={{ marginBottom: "20px", textAlign: "center" }}
                  >
                    Matched Profiles
                  </Typography>
                  <Grid container spacing={2}>
                    {multipleMatchedData.patient.map((patient, index) => (
                      <Grid item xs={12} sm={6} key={index}>
                        <Card
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            minHeight: "265px",
                          }}
                        >
                          <CardContent
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                              height: "100%",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Avatar
                                  alt={patient.name}
                                  src={`data:image/jpeg;base64,${patient.photo}`}
                                  style={{ marginRight: "20px" }}
                                />
                                <div>
                                  <Typography variant="h6">
                                    {patient.name}
                                  </Typography>
                                  <Typography variant="body2">
                                    ABHA Number: {patient.abha_no || "-"}
                                  </Typography>
                                  <Typography variant="body2">
                                    Patient ID: {patient.patient_id}
                                  </Typography>
                                  <Typography variant="body2">
                                    ABHA Address: {patient.abha_id || "-"}
                                  </Typography>
                                  <Typography variant="body2">
                                    Gender: {patient.gender}
                                  </Typography>
                                  <Typography variant="body2">
                                    DOB: {patient.dob}
                                  </Typography>
                                </div>
                              </div>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginTop: "10px",
                              }}
                            >
                              <Tooltip title="Add New Patient">
                                <IconButton
                                  onClick={() => handleAddNewPatient(patient)}
                                  aria-label="add new patient"
                                  sx={{ color: "yellow" }}
                                >
                                  <PersonAddAlt1Icon />
                                </IconButton>
                              </Tooltip>

                              <Tooltip title="Update Patient">
                                <IconButton
                                  onClick={() => handleUpdatePatient(patient)}
                                  aria-label="update patient"
                                  sx={{ color: "green" }}
                                >
                                  <ManageAccountsIcon />
                                </IconButton>
                              </Tooltip>

                              <Tooltip title="Cancel Update">
                                <IconButton
                                  onClick={() =>
                                    handleCancelUpdate(patient.patient_id)
                                  }
                                  aria-label="cancel update"
                                  sx={{ color: "red" }}
                                >
                                  <CancelIcon />
                                </IconButton>
                              </Tooltip>
                            </div>
                          </CardContent>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                </form>
              </Box>
            )} */}

          {multipleMatchedData && multipleMatchedData.patient ? (
            multipleMatchedData.patient.length > 0 ? (
              <>
                <ProfileCard
                  profileData={{
                    healthIdNumber:
                      multipleMatchedData.healthIdNumber ||
                      multipleMatchedData.ABHANumber,
                    healthId:
                      multipleMatchedData.healthId ||
                      multipleMatchedData.preferredAbhaAddress,
                    name:
                      multipleMatchedData.name ||
                      `${multipleMatchedData.firstName} ${multipleMatchedData.lastName}`,
                    yearOfBirth: multipleMatchedData.yearOfBirth,
                    monthOfBirth: multipleMatchedData.monthOfBirth,
                    dayOfBirth: multipleMatchedData.dayOfBirth,
                    profilePhoto:
                      multipleMatchedData.profilePhoto ||
                      multipleMatchedData.kycPhoto,
                    gender: multipleMatchedData.gender,
                  }}
                />
                <Box
                  sx={{
                    height: "600px",
                    overflow: "auto",
                    padding: "16px",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                  }}
                >
                  <form>
                    <Typography
                      variant="h6"
                      style={{ marginBottom: "20px", textAlign: "center" }}
                    >
                      Matched Profile(s) in the facility
                    </Typography>
                    <Grid container spacing={2}>
                      {multipleMatchedData.patient.map((patient, index) => (
                        <Grid item xs={12} sm={6} key={index}>
                          <Card
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              minHeight: "265px",
                              border:
                                activePatientId === patient.patient_id
                                ? "2px solid #21cdc0"
                                  : "none",
                            }}
                            onClick={() => handleCardSelect(patient.patient_id)}
                          >
                            <CardContent
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                height: "100%",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Avatar
                                    alt={patient.name}
                                    src={`data:image/jpeg;base64,${patient.photo}`}
                                    style={{ marginRight: "20px" }}
                                  />
                                  <div>
                                    <Typography variant="h6">
                                      {patient.name}
                                    </Typography>
                                    <Typography variant="body2">
                                      ABHA Number: {patient.abha_no || "-"}
                                    </Typography>
                                    <Typography variant="body2">
                                      Patient ID: {patient.patient_id}
                                    </Typography>
                                    <Typography variant="body2">
                                      ABHA Address: {patient.abha_id || "-"}
                                    </Typography>
                                    <Typography variant="body2">
                                      Gender: {patient.gender}
                                    </Typography>
                                    <Typography variant="body2">
                                      DOB: {patient.DOB}
                                    </Typography>
                                  </div>
                                </div>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  marginTop: "10px",
                                }}
                              >
                                {/* <Tooltip title="Add New Patient">
                                <IconButton
                                  onClick={() => handleAddNewPatient(patient)}
                                  aria-label="add new patient"
                                  sx={{ color: "green" }}
                                >
                                  <PersonAddAlt1Icon />
                                </IconButton>
                              </Tooltip> */}

                                {/* <Tooltip title="Update Patient">
                                  <IconButton
                                    onClick={() => handleUpdatePatient(patient)}
                                    aria-label="update patient"
                                    sx={{ color: "#ffa233" }}
                                  >
                                    <ManageAccountsIcon />
                                  </IconButton>
                                </Tooltip> */}

                                {/* <Tooltip title="Cancel Update">
                                <IconButton
                                  onClick={() =>
                                    handleCancelUpdate(patient.patient_id)
                                  }
                                  aria-label="cancel update"
                                  sx={{ color: "red" }}
                                >
                                  <CancelIcon />
                                </IconButton>
                              </Tooltip> */}
                              </div>
                            </CardContent>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  </form>
                </Box>

                {/* <Card>
                  <CardContent>
                    <Typography variant="h6" style={{ textAlign: "center" }}>
                    Other Actions
                    </Typography>
                    <Box display="flex" justifyContent="center" mt={2}>
                      <Tooltip title="Add New Patient">
                        <IconButton
                          onClick={handleAddNewPatient}
                          aria-label="add new patient"
                          sx={{ color: "yellow" }}
                        >
                          <PersonAddAlt1Icon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Cancel">
                        <IconButton
                          onClick={() => handleCancelUpdate()}
                          aria-label="cancel"
                          sx={{ color: "red" }}
                        >
                          <CancelIcon />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </CardContent>
                </Card> */}
                <Card>
                  <CardContent>
                    <Typography variant="h6" style={{ textAlign: "center" }}>
                      Actions
                    </Typography>
                    <Box display="flex" justifyContent="center" mt={2}>
                      {/* Add Patient */}
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        mx={2}
                      >
                        <Tooltip title="Add New Patient" arrow>
                          <IconButton
                            onClick={handleAddNewPatient}
                            aria-label="add new patient"
                            sx={{ color: "green" }}
                          >
                            <PersonAddAlt1Icon />
                          </IconButton>
                        </Tooltip>
                        <Typography variant="caption">Add Patient</Typography>
                      </Box>
                      {/* Update Action */}

                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        mx={2}
                      >
                        <Tooltip title="Update Patient">
                          <IconButton
                            onClick={() => handleUpdatePatient(activePatientId)}
                            aria-label="update patient"
                            disabled={!activePatientId}
                            sx={{ color: "#ffa233" }}
                          >
                            <ManageAccountsIcon />
                          </IconButton>
                        </Tooltip>
                        <Typography variant="caption">
                          Update Patient
                        </Typography>
                      </Box>
                      {/* Cancel Action */}
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        mx={2}
                      >
                        <Tooltip title="Cancel" arrow>
                          <IconButton
                            onClick={handleCancelUpdate}
                            aria-label="cancel"
                            sx={{ color: "red" }}
                          >
                            <CancelIcon />
                          </IconButton>
                        </Tooltip>
                        <Typography variant="caption">Cancel</Typography>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </>
            ) : (
              <Card>
                <CardContent>
                  <Typography variant="h6" style={{ textAlign: "center" }}>
                    No Patient Found
                  </Typography>
                  <Box display="flex" justifyContent="center" mt={2}>
                    <Tooltip title="Add New Patient">
                      <IconButton
                        onClick={handleAddNewPatient}
                        aria-label="add new patient"
                        sx={{ color: "green" }}
                      >
                        <PersonAddAlt1Icon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Cancel">
                      <IconButton
                        onClick={() => handleCancelUpdate()}
                        aria-label="cancel"
                        sx={{ color: "red" }}
                      >
                        <CancelIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </CardContent>
              </Card>
            )
          ) : null}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseGenerateModal}>
            Done
          </Button>
          {/* Add additional buttons or actions as needed */}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default GenerateAbha;
